import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import '@shopify/polaris/build/esm/styles.css';

// Silence front-end debug logs when requested
if (process.env.REACT_APP_SILENCE_DEBUG === 'true' || process.env.NODE_ENV === 'production') {
  console.debug = () => {};
  // Uncomment to mute console.log as well
  // console.log = () => {};
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
